// axios
import axios from "axios";
//const domain = "https://localhost:44338/"
const domain = "https://api.copticlib.org/";
//const domain = "http://173.249.43.159:89/";
//const domain = "http://207.180.213.97:7070/";
//const domain = "http://api.copticlib.org/";

axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("Token");

export default axios.create({
    baseURL: domain,
    // You can add your headers here
});